import { club } from '@/store/module/club/mutation/club.js';
import { clubs } from '@/store/module/club/mutation/clubs.js';
import { edit } from '@/store/module/club/mutation/edit.js';
import { reset } from '@/store/module/club/mutation/reset.js';

export const mutations = {
	club,
	clubs,
	edit,
	reset
};
